/**
 * @generated SignedSource<<3c84311d919cb3d34fcdb2c130148fd8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternIntegrationsCard_brand$data = {
  readonly facebookConfig: {
    readonly id: string;
    readonly needsReauth: boolean;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "InternIntegrationsCard_brand";
};
export type InternIntegrationsCard_brand$key = {
  readonly " $data"?: InternIntegrationsCard_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternIntegrationsCard_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternIntegrationsCard_brand",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLFacebookClientConfig",
      "kind": "LinkedField",
      "name": "facebookConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "needsReauth",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "30927c620c9654914b8d1848dd7bf840";

export default node;
